<template>
    <div class="d-tabs">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'DTabs'
}
</script>

<style lang="scss" scoped>
.d-tabs {
    display: flex;
    align-items: center;
}
</style>
